import {createAction} from 'typesafe-actions';
import {IDownloadLinks} from '../../../typings/general';
import {TTrack} from '../../../typings/todo';
import {CLOSE_BUTTONS_CONSTANT} from '../../components/Page/CloseButtonsConstant';
import {BiError} from '../../services/biErrorLogger/biErrorLoggerFactory';

export const onNameYourPriceEnteredAction = createAction('NAME_YOUR_PRICE_ENTERED')<{price: number}>();
export const backButtonAction = createAction('BACK_BUTTON_ACTION')();
export const retryPaymentAction = createAction('RETRY_PAYMENT_ACTION')();
export const closeAction = createAction('CLOSE_BUTTON_ACTION')<CLOSE_BUTTONS_CONSTANT>();
export const emailGotAction = createAction('EMAIL_GOT')<{email: string}>();

export const emailGotInvalidAction = createAction('EMAIL_GOT_INVALID')<{errorMsg: string}>();
export const continuePaymentAction = createAction('CONTINUE_PAYMENT_ACTION')();

export const cashierMandatoryFieldsAction = createAction('CASHIER_MANDATORY_FIELDS_ACTION')<Record<string, string>>();
export const cashierWidgetLoadStateAction = createAction('CASHIER_WIDGET_LOAD_STATE_ACTION')<boolean>();
export const downloadLinksSuccessAction = createAction('DOWNLOAD_LINKS_SUCCESS_ACTION')<IDownloadLinks>();
export const payWithCashierSuccessAction = createAction('PAY_WITH_CASHIER/SUCCESS')();
export const payWithCashierFailureAction = createAction('PAY_WITH_CASHIER/FAILURE')<{errorMessage: string}>();
export const payWithCashierPendingAction = createAction('PAY_WITH_CASHIER/PENDING')();
export const payWithCashierCanceledAction = createAction('PAY_WITH_CASHIER/CANCEL')();

export const getAlbumAction = createAction('GET_ALBUM_ACTION')();
export const getTrackAction = createAction('GET_TRACK_ACTION')<{track: TTrack}>();

export const sendBiErrorAction = createAction('SEND_BI_EVENT')<BiError>();
